import { Routes } from '@angular/router';
import { requireAuthGuard } from './shared/guards/require-auth.guard';
import { postListResolver } from './features/home/post-list.resolver';
import { postDetailResolver } from './features/post/post-detail.resolver';
import { seriesListResolver } from './features/series/series-list.resolver';
import { seriesDetailResolver } from './features/series/series-detail.resolver';

export const routes: Routes = [
  {
    path: '',
    resolve: { resolvedData: postListResolver },
    loadComponent: () =>
      import('./features/home/post-list/post-list.component').then(m => m.PostListComponent)
  },
  {
    path: 'type/:postType',
    resolve: { resolvedData: postListResolver },
    loadComponent: () =>
      import('./features/home/post-list/post-list.component').then(m => m.PostListComponent)
  },
  {
    path: 'post/:slugOrId',
    resolve: { resolvedData: postDetailResolver },
    loadComponent: () =>
      import('./features/post/post-detail/post-detail.component').then(m => m.PostDetailComponent)
  },
  {
    path: 'series',
    resolve: { resolvedData: seriesListResolver },
    loadComponent: () =>
      import('./features/series/series-list-page/series-list-page.component').then(m => m.SeriesListPageComponent)
  },
  {
    path: 'series/:slug',
    resolve: { resolvedData: seriesDetailResolver },
    loadComponent: () =>
      import('./features/series/series-detail/series-detail.component').then(m => m.SeriesDetailComponent)
  },
  {
    path: 'bookmarks',
    canActivate: [requireAuthGuard],
    loadComponent: () =>
      import('./features/bookmarks/bookmark-list/bookmark-list.component').then(m => m.BookmarkListComponent)
  },
  {
    path: 'profile',
    canActivate: [requireAuthGuard],
    loadComponent: () =>
      import('./features/profile/profile-page/profile-page.component').then(m => m.ProfilePageComponent)
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./features/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./features/contact/contact.component').then(m => m.ContactComponent)
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.authRoutes)
  },
  { path: '**', redirectTo: '' }
];
